// Pure loader-state reducer for the unified forecast poll. Keeps the bar
// honest: clamp pct to the max seen (no backward jumps on a server stage reset)
// and ignore the "ready" no-row sentinel so a poll that beats the worker's first
// stage write never snaps the bar to 100. No React here.
import type { ForecastStatus, WarmState } from "@shared/warm-progress";

export interface PollState {
  pct: number;
  stage: WarmState | null;
}

export const INITIAL_POLL: PollState = { pct: 0, stage: null };

export function advancePoll(prev: PollState, status: ForecastStatus): PollState {
  const raw = status.stage === "ready" ? 0 : status.pct;
  return { pct: Math.max(prev.pct, raw), stage: status.stage };
}
